var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mainContainer" } },
    [
      _c(
        "ResSplitPane",
        {
          staticClass: "splitPaneColumn",
          staticStyle: { height: "100%", position: "initial" },
          attrs: {
            "split-to": "columns",
            "allow-resize": true,
            "min-size": 111,
            "max-size": 600,
            size: _vm.sizeSplitPane,
            units: "pixels"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { height: "100%" },
              attrs: { slot: "firstPane" },
              slot: "firstPane"
            },
            [
              _c(
                "ResSplitPane",
                {
                  staticStyle: { height: "100%", position: "initial" },
                  attrs: {
                    "split-to": "rows",
                    "allow-resize": false,
                    "min-size": 35,
                    "max-size": 100,
                    size: 70,
                    units: "percents"
                  }
                },
                [
                  _c(
                    "v-card",
                    {
                      attrs: { slot: "firstPane", id: "patentsContainer" },
                      slot: "firstPane"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wrap layout",
                          attrs: { id: "searchDiv" }
                        },
                        [
                          _c(
                            "div",
                            [
                              _vm.isFilter
                                ? _c("v-autocomplete", {
                                    key: _vm.key,
                                    attrs: {
                                      items: _vm.rutsForSelect(),
                                      "item-value": "id_dispositivo",
                                      "item-text": _vm.textoOpcion,
                                      label: "Dispositivo",
                                      "single-line": "",
                                      "data-vv-name": "selectedValue",
                                      color: "primary",
                                      clearable: true,
                                      "no-data-text": "Sin resultados",
                                      required: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.dispositivoSeleccionado()
                                      }
                                    },
                                    model: {
                                      value: _vm.selectedValue,
                                      callback: function($$v) {
                                        _vm.selectedValue = $$v
                                      },
                                      expression: "selectedValue"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c("div", { attrs: { id: "patentsDiv" } }, [
                        _vm.isFilter
                          ? _c("div", [
                              !_vm.isSelected
                                ? _c(
                                    "div",
                                    [
                                      _c("v-icon", [_vm._v("close-circle")]),
                                      _c("span", [
                                        _vm._v(
                                          "Aún no se ha seleccionado un dispositivo "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.marca == "STREAMAX"
                                ? _c(
                                    "div",
                                    [
                                      _c("v-list-subheader", [
                                        _vm._v("STREAMAX")
                                      ]),
                                      _vm.isSelected
                                        ? _c(
                                            "v-list",
                                            {
                                              attrs: {
                                                dense: "",
                                                filter: _vm.filter
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-item-group",
                                                {
                                                  attrs: { color: "primary" },
                                                  model: {
                                                    value: _vm.treeViewList,
                                                    callback: function($$v) {
                                                      _vm.treeViewList = $$v
                                                    },
                                                    expression: "treeViewList"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.itemsStreamax,
                                                  function(item, i) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: i,
                                                        attrs: {
                                                          color: "purple"
                                                        }
                                                      },
                                                      [
                                                        [
                                                          _c(
                                                            "v-list-tile",
                                                            {
                                                              staticClass:
                                                                "hover-grey",
                                                              attrs: {
                                                                outlined: "",
                                                                rounded: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                {
                                                                  staticStyle: {
                                                                    cursor:
                                                                      "pointer",
                                                                    "font-size":
                                                                      "15px"
                                                                  },
                                                                  attrs: {
                                                                    color:
                                                                      "blue"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleList(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "selected-item":
                                                                          _vm.treeViewList ===
                                                                          item.name
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            item.label
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.marca == "HOWEN"
                                ? _c(
                                    "div",
                                    [
                                      _c("v-list-subheader", [_vm._v("HOWEN")]),
                                      _vm.isSelected
                                        ? _c(
                                            "v-list",
                                            {
                                              attrs: {
                                                dense: "",
                                                filter: _vm.filter
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-item-group",
                                                {
                                                  attrs: { color: "primary" },
                                                  model: {
                                                    value: _vm.treeViewList,
                                                    callback: function($$v) {
                                                      _vm.treeViewList = $$v
                                                    },
                                                    expression: "treeViewList"
                                                  }
                                                },
                                                _vm._l(_vm.itemsHowen, function(
                                                  item,
                                                  i
                                                ) {
                                                  return _c(
                                                    "v-list-item",
                                                    {
                                                      key: i,
                                                      attrs: { color: "purple" }
                                                    },
                                                    [
                                                      [
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            staticClass:
                                                              "hover-grey",
                                                            attrs: {
                                                              outlined: "",
                                                              rounded: ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticStyle: {
                                                                  cursor:
                                                                    "pointer",
                                                                  "font-size":
                                                                    "15px"
                                                                },
                                                                attrs: {
                                                                  color: "blue"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleList(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    class: {
                                                                      "selected-item":
                                                                        _vm.treeViewList ===
                                                                        item.name
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          item.label
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    ],
                                                    2
                                                  )
                                                }),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _c(
                    "v-card",
                    {
                      attrs: { slot: "secondPane", id: "detailsContainer" },
                      slot: "secondPane"
                    },
                    [
                      _vm.isSelected
                        ? _c("div", [
                            _vm.mensaje == "MDVR sin grabar registros"
                              ? _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("i", {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        width: "24px",
                                        height: "24px",
                                        "margin-top": "4%",
                                        "border-radius": "50%",
                                        background: "rgb(252, 30, 1)"
                                      },
                                      attrs: { title: "En Línea" }
                                    }),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#4f4f4f",
                                          "margin-top": "5%",
                                          "margin-left": "3%"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.mensaje) +
                                            "\n                " +
                                            _vm._s(_vm.date) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("i", {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        width: "24px",
                                        height: "24px",
                                        "margin-top": "4%",
                                        "border-radius": "50%",
                                        background: "rgb(33, 33, 255)"
                                      },
                                      attrs: { title: "En Línea" }
                                    }),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#4f4f4f",
                                          "margin-top": "5%",
                                          "margin-left": "3%"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Sin Información\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                          ])
                        : _c(
                            "div",
                            {
                              staticStyle: { overflow: "hidden" },
                              attrs: { id: "withoutPatent" }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("div", { attrs: { id: "textEmpty" } }, [
                                    _vm._v("No ha seleccionado ninguna cámara")
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/emptyIcon.png")
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            {
              attrs: { slot: "secondPane", id: "camContainer" },
              slot: "secondPane"
            },
            [
              _c("div", { attrs: { id: "first" } }, [
                _vm.emptyPatentCam
                  ? _c(
                      "div",
                      { attrs: { id: "withoutPatent" } },
                      [
                        _vm.formView == "RegistInfoStreamax"
                          ? _c("FormRegistInfoStreamax", {
                              attrs: {
                                selectedValue: _vm.selectedValue,
                                esEdicion: _vm.esEdicion,
                                usuario: _vm.id
                              }
                            })
                          : _vm._e(),
                        _vm.formView == "TimeSetUpStreamax"
                          ? _c("FormTimeSetupStreamax", {
                              attrs: {
                                selectedValue: _vm.selectedValue,
                                esEdicion: _vm.esEdicion,
                                usuario: _vm.id
                              }
                            })
                          : _vm._e(),
                        _vm.formView == "NetworkStreamax"
                          ? _c("NetworkStreamax", {
                              attrs: {
                                selectedValue: _vm.selectedValue,
                                esEdicion: _vm.esEdicion,
                                usuario: _vm.id
                              }
                            })
                          : _vm._e(),
                        _vm.formView == "RecordStreamax"
                          ? _c("RecordStreamax", {
                              attrs: {
                                selectedValue: _vm.selectedValue,
                                esEdicion: _vm.esEdicion,
                                usuario: _vm.id
                              }
                            })
                          : _vm._e(),
                        _vm.formView == "sysconfigHowen"
                          ? _c("FormSysConfigHowen", {
                              attrs: {
                                selectedValue: _vm.selectedValue,
                                esEdicion: _vm.esEdicion,
                                usuario: _vm.id
                              }
                            })
                          : _vm._e(),
                        _vm.formView == "recsetupHowen"
                          ? _c("FormRecSetUpHowen", {
                              attrs: {
                                selectedValue: _vm.selectedValue,
                                esEdicion: _vm.esEdicion,
                                usuario: _vm.id
                              }
                            })
                          : _vm._e(),
                        _vm.formView == "networkHowen"
                          ? _c("FormNetworkHowen", {
                              attrs: {
                                selectedValue: _vm.selectedValue,
                                esEdicion: _vm.esEdicion,
                                usuario: _vm.id
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.emptyPatentCam,
                            expression: "!emptyPatentCam"
                          }
                        ],
                        staticStyle: { overflow: "hidden" },
                        attrs: { id: "withoutPatent" }
                      },
                      [
                        _c("div", { staticStyle: { "text-align": "center" } }, [
                          _c("div", { attrs: { id: "textEmpty" } }, [
                            _vm._v("No ha seleccionado ninguna opción")
                          ]),
                          _c("img", {
                            attrs: { src: require("@/assets/emptyIcon.png") }
                          })
                        ])
                      ]
                    )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }